import { Quiz } from './Quiz';
import { QuizResult } from './QuizResult';

export enum QuizQuestionFormError {
    SAME_QUESTION_DESCRIPTION = 'sameQuestionDescription',
}

export interface QuizQuestionFormStateError {
    descriptionError: string | undefined;
}

export interface Option {
    id?: number;
    description: string;
    result: QuizResult | null;
}

export interface QuizQuestionForm {
    order: number;
    image: string | undefined;
    description: string;
    options: Option[];
}

export interface QuizQuestionId {
    id: number;
    quiz: Quiz;
}

export type QuizQuestion = QuizQuestionId & QuizQuestionForm;
